export const ANCLAS = {
  ROOT: "/",
  ALEANTE: "https://aleante.com.mx",
  LABORATORIO: "https://lab.msw.com.mx",
  Cuidarte: "https://cuid-arte.com.mx",
  DESARROLLO: "https://desarrollo.msw.com.mx",
  AMBIENTAL: "https://ambiental.msw.com.mx",
};
